<template>
  <div class="w-full h-full">
    <div class="flex">
      <el-select
        size="small"
        class="mr-10px flex-1"
        placeholder="请选择物资类型"
        v-model="searchData.suppliesType"
        clearable
        @change="handleSearch()"
        popper-class="visualization-select-popper"
      >
        <el-option
          v-for="(item, index) in typeList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        placeholder="名称、编码"
        v-model="searchData.keywords"
        size="small"
        clearable
        @keypress.enter.native="handleSearch()"
        class="icon-search__input mb-10px flex-1"
      >
        <i
          slot="append"
          class="el-icon-search cursor-pointer icon-search__input"
          @click="handleSearch()"
        ></i>
      </el-input>
    </div>
    <el-table
      :data="tableData"
      highlight-current-row
      :height="tableHeight"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="物资名称" prop="name" show-overflow-tooltip />
      <el-table-column label="物资编码" prop="codeStr" show-overflow-tooltip />
      <el-table-column label="物资点位" prop="suppliesSiteName" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span class="text-hex-00bcc8 cursor-pointer" @click="goDetail(row)">{{
            row.suppliesSiteName
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      :pager-count="5"
      layout="prev, pager, next"
      :total="total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
import {
  SuppliesTypeApi,
  SuppliesManagementApi,
  SuppliesSiteApi,
} from '@wiz-api/emergency-management'
import { AreaApi } from '@wiz-api/area-management'
import { find } from 'lodash'
import bus from './bus'
import { suppliesIconList } from '../../../assets/js/componentMethods/emergencySupplies'

const areaApi = new AreaApi()

const suppliesManagementApi = new SuppliesManagementApi()
const suppliesTypeApi = new SuppliesTypeApi()
export default {
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      typeList: [],
      tableData: [],
      tableLoading: true,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      searchData: {},
      total: 0,
      metalBimBaseData: {},
      areaList: [],
      areaId: '',
      sceneId: '',
    }
  },
  async created() {
    await this.getAreaList()
    this.findList()
    this.getType()
    window.addEventListener('sendAreaId', this.areaIdChange)
  },
  mounted() {
    if (this.transferProps?.data) {
      this.goDetail(this.transferProps?.data)
    }
  },
  methods: {
    areaIdChange(e) {
      this.areaId = e.detail.areaId
      this.findList()
    },
    // 获取风险区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        modelId: this.sceneId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && res) {
        this.areaList = res.items
      }
    },
    handleDetail(row) {
      // 模型弹窗不需要，弹详情
      // const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
      //   detail: {
      //     row,
      //     type: 'emergencyMatter',
      //   },
      // })
      // window.dispatchEvent(openEvent)
    },
    async findList() {
      this.tableLoading = false
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
        areaId: [this.areaId],
      }
      if (!this.areaId) {
        data.areaId = this.areaList.map((item) => {
          return item.id
        })
      }
      this.loading = true
      const [err, res] = await suppliesManagementApi.getList(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 获取物资类型
    async getType() {
      const params = {
        skipCount: 0,
        maxResultCount: 99,
      }
      const [err, data] = await suppliesTypeApi.getList(params)
      if (!err) {
        this.typeList = data.items
      }
    },
    handleSearch() {
      this.pageConfig.pageNo = 1
      this.findList()
    },
    // 页码改变
    sizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    currentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.findList()
    },
    // 去详情
    goDetail(data) {
      if (data.suppliesSite) {
        const marker = find(suppliesIconList, { suppliesSite: data.suppliesSite })
        if (marker) {
          cloudRender.Engine.player.Native.Camera.moveToPos(marker.pos, 0, 10, 2)
        }
      }
      bus.$emit('translate', { row: data, type: 'material' })
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.areaId = data.areaId
        this.sceneId = data.sceneId
        this.findList()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}

::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  padding: 0 4px;
  margin: 0 5px;
  min-width: 24px;
}
</style>
